import React from 'react';
import { Link } from 'react-scroll';
import { motion } from 'framer-motion';
import { TbBrandGithub, TbBrandLinkedin, TbMail } from 'react-icons/tb';
import { fadeInUp } from '../../components/functions/animation';
import './CTABanner.css';

const CTABanner = () => (
  <section id="cta-banner" aria-label="Call to action – Hire Me">
    <div className="cta-banner-glow" aria-hidden="true" />
    <div className="container">
      <motion.div
        className="cta-banner-inner"
        variants={fadeInUp}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.3 }}
      >
        {/* Available dot */}
        <div className="cta-avail">
          <span className="cta-avail-dot" />
          <span className="cta-avail-text">Open to New Opportunities</span>
        </div>

        {/* Inspirational quote */}
        <p className="cta-quote">"Great code starts with a great conversation."</p>

        <h2 className="cta-heading">
          Have a project in mind?<br />
          <span>Let's build it together.</span>
        </h2>

        <p className="cta-sub">
          I'm currently available for freelance work, full-time roles, and exciting collaborations.
          Whether it's a web app, an AI tool, or a startup idea — let's make it happen.
        </p>

        {/* Action row */}
        <div className="cta-actions">
          <Link
            className="btn-primary cta-btn-primary"
            to="contact"
            href="/#contact"
            smooth
            duration={500}
          >
            <TbMail />
            Get In Touch
          </Link>
          <a
            className="btn-outline cta-btn-outline"
            href="/documents/obaidullah-zeeshan-software-engineer.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            View Resume
          </a>
          <a
            className="btn-ghost cta-btn-ghost"
            href="/documents/obaidullah-zeeshan-software-engineer.pdf"
            download="Obaidullah_Zeeshan_CV.pdf"
          >
            Download CV
          </a>
        </div>

        {/* Social row */}
        <div className="cta-socials">
          <a href="https://github.com/ObaidGits" target="_blank" rel="noopener noreferrer" aria-label="GitHub" className="cta-social">
            <TbBrandGithub />
          </a>
          <a href="https://www.linkedin.com/in/obaidullah-zeeshan/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="cta-social">
            <TbBrandLinkedin />
          </a>
          <a href="mailto:obaidzeeshan.official@gmail.com" aria-label="Email" className="cta-social">
            <TbMail />
          </a>
        </div>
      </motion.div>
    </div>
  </section>
);

export default CTABanner;
